<template>
    <div class="echart" :id="id"></div>
</template>
<script>
export default {
    name:'lineChart',
    data(){
         return {
             chart:''
         }
    },
    props: {
        id:{
            type:String
        },
        dataArray: { 
            type: Array | Object
        },
        isShowLegend: { 
            type: Boolean,
            default:function(){
               return true 
            }
        },
        isShowArea: { 
            type: Boolean,
            default:function(){
               return true 
            }
        },
        gridBot:{
            type:String,
            default:'55'
        },
        colorArr:{
            type: Array,
            default: function () {
                return ["#0097e2", "#ff8121", "#e52e45"]
            }
        }
    },
    mounted() {
        let that = this
        that.$nextTick(()=> {
            that.init();
        })
    },
    watch: {
        'dataArray': function (n, o) {
            this.init();
        }
    },
    methods: {
        lineOption:function(){
            let _this = this;
            let dtname = this.dataArray.dataName;
            var option = {
                    tooltip : {
                    trigger: 'axis'
                },
                legend: {
                    show:_this.isShowLegend,
                    data:dtname,
                    textStyle: {
                        color: '#8a8a99',
                        fontSize:'14'
                    },
                    top:'top',
                    left:'left',
                    itemWidth: 12,
                    itemHeight: 12,
                    itemGap: 15,
                    icon:'roundRect'
                },
                grid: {
                    top: '50',
                    left: '10',
                    right: '10',
                    bottom: '10',
                    containLabel: true
                },
                // toolbox: {
                //     feature: {
                //         saveAsImage: {
                //             title: '下载',
                //         }
                //     }
                // },
                color: _this.colorArr,
                calculable : true,
                xAxis : [
                    {
                        type : 'category',
                        //boundaryGap : false,
                        data : _this.dataArray.datetime,
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLine: {
                            show: true,
                            lineStyle:{
                                color:'#ebebeb',
                            }
                        },
                        axisLabel : {
                            formatter: '{value}',
                            margin:15,
                            textStyle: {
                                color: '#8a8a99',
                                fontSize:'12'
                            }
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: ['#ebebeb']
                            }  
                        },
                    }
                ],
                yAxis : [
                    {
                        type : 'value',
                        axisTick: {
                            textStyle: {
                                color: '#aaa'
                            }
                        },
                        axisLine: {
                            show: false,
                            lineStyle:{
                                color:'#ebebeb',
                            }
                        },
                        axisLabel : {
                            //formatter: '{value}',
                            formatter: function(params) {
                                let newParams='';
                                if(params.toString().length>3){
                                    newParams = params/1000 + 'K'
                                }else{
                                    newParams = params
                                }
                                return newParams;
                            },
                            textStyle: {
                                color: '#8a8a99',
                                fontSize:'12'
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: ['#ebebeb']
                            }  
                        },
                    }
                ],
                series:_this.getLineSeries(dtname)
            }
            return option;
        },
        getLineSeries:function(dtname){
            let seriesArr =[],_this = this,colorArea;
            if(_this.isShowArea){
                colorArea = [
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(39,153,223, .3)'},
                            {offset: 1,color: 'rgba(39,153,223, 0)'}
                        ])
                    },
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(31, 197, 25,.3)'},
                            {offset: 1,color: 'rgba(31, 197, 25,0)'}
                        ])
                    },
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(255, 175, 48, .3)'},
                            {offset: 1,color: 'rgba(255, 175, 48, 0)'}
                        ])
                    },
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(255, 87, 87, .3)'},
                            {offset: 1,color: 'rgba(255, 87, 87, 0)'}
                        ])
                    },
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(39, 234, 227, .3)'},
                            {offset: 1,color: 'rgba(39, 234, 227, 0)'}
                        ])
                    }
                ];
            }else{
                colorArea=[];
            }
            
            
            for(var i=0;i<dtname.length;i++){
                var tempSeries = _this.setLineSeries(dtname[i], colorArea[i],_this.dataArray[dtname[i]]);
                seriesArr.push(tempSeries);
            }
            return  seriesArr;
        },
        setLineSeries:function(name,colorArea, data) {
            let series = {
                name:name,
                type:'line',
                smooth:true,
                symbolSize: 1,
                symbol: 'emptycircle',
                itemStyle: {
                    normal: {
                        label: {
                            formatter: function(params) {
                                return dataValue - params.value;
                            },
                            fontSize: 40,
                            padding: [90, 0, 0, 0],
                            color: '#fff',
                            textStyle: {
                                baseline: 'top'
                            }
                        },
                    }
                },
                areaStyle:colorArea,
                data:data
            };
            return series;
        },
        init(){
            let _this = this;
            _this.$echarts.init(document.getElementById(_this.id)).dispose();
            _this.chart = _this.$echarts.init(document.getElementById(_this.id));
            _this.chart.setOption(_this.lineOption());
            window.addEventListener("resize",function(){
                _this.chart.resize(); 
            });
        },
    },
}
</script>
<style lang="" scoped>
    .echart{width:100%;height:100%}
</style>


// WEBPACK FOOTER //
// src/components/echart/lineChart1.vue